(function() {
    'use strict';

    angular.module('appliances')
        .controller('AppliancesCreateController', AppliancesCreateController);

    AppliancesCreateController.$inject = ['$state', 'appliancesDataSrvc', 'notificationSrvc', 'appliancesMessagesConst', 'errorNotificationSrvc'];

    function AppliancesCreateController($state, appliancesDataSrvc, notificationSrvc, appliancesMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            description_pl: [],
            name_en: [],
            description_en: [],
            title_de: [],
            description_de: [],
            title_cpde: [],
            description_cpde: [],
            title_cpen: [],
            description_cpen: [],
            nonFieldErrors: []
        };
        self.applianceData = {
            name_pl: '',
            description_pl: '',
            name_en: '',
            description_en: '',
            name_de: '',
            description_de: '',
            name_cpde: '',
            description_cpde: '',
            name_cpen: '',
            description_cpen: ''
        };
        self.appliances = [];

        self.createAppliance = createAppliance;
        self.cleanErrors = cleanErrors;

        function createAppliance() {
            appliancesDataSrvc.create(
                self.applianceData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", appliancesMessagesConst.add);
                    $state.go('layout.appliances.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
